import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Button } from '../components/ui/button';

export default function AffiliateEmailVerification() {
  const params = new URLSearchParams(window.location.hash.slice(1));
  const applicationId = params.get('application_id') || '';
  const token = params.get('token') || '';
  const [status, setStatus] = useState('Conferma il tuo indirizzo email per inviare la candidatura alla valutazione manuale.');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await api.post('/affiliates/applications/verify-email', { application_id: applicationId, token });
      setDone(true);
      setStatus('Email verificata. La candidatura è ora in valutazione.');
      window.history.replaceState(null, '', window.location.pathname);
    } catch (error) {
      setStatus(error.response?.data?.detail || 'Link di verifica non valido o scaduto.');
    } finally { setBusy(false); }
  };

  return <main className="page-shell py-14 max-w-xl space-y-5">
    <p className="eyebrow">Programma partner</p>
    <h1 className="font-display text-3xl font-bold text-brand-dark">Verifica la candidatura</h1>
    <p role="status" className="text-slate-600">{status}</p>
    {applicationId && token && !done && <Button disabled={busy} onClick={confirm} className="bg-brand text-white">
      {busy ? 'Verifica…' : 'Conferma indirizzo email'}
    </Button>}
    {(!applicationId || !token) && <p className="text-sm text-rose-700">Il link non contiene i dati necessari.</p>}
    <Link className="block text-brand underline" to="/programma-partner">Torna al Programma Partner</Link>
  </main>;
}
